/** Shared definitions for HTML report models. */

export const REPORT_SCHEMA_VERSION = 1;

export const REPORT_TYPES = {
  organization: "organization",
  circularity: "circularity",
};

// Longest free-text value carried into a report (LLM-prefilled assessment text can be long).
export const MAX_TEXT_LENGTH = 4000;

/**
 * Coerces a value to trimmed plain text. Rendering always goes through React text nodes,
 * so this only bounds size and removes control characters; it does not need to escape HTML.
 */
export const plainText = (value, maxLength = MAX_TEXT_LENGTH) => {
  if (value === null || value === undefined) return "";
  return String(value)
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, "")
    .trim()
    .slice(0, maxLength);
};
